import type { StripeValidationErrors } from '#src/app/shared/utils/payments';
import { stripeErrorI18nKey, stripeInputName } from '#src/app/shared/utils/payments';

import type { StripeElementChangeEvent } from '../index';

export function getUpdatedValidationErrors(
	prev: StripeValidationErrors,
	e: StripeElementChangeEvent,
): StripeValidationErrors {
	return {
		...prev,
		[stripeInputName(e.elementType) as string]: e.error ? stripeErrorI18nKey(e.error) : null,
	};
}
